import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import React from "react";
import { notifySomething } from "../_Utils/AppDocuCommon";
import GenDocumentDialogForm from "./_GenDocumentDialogForm";
import AppDocuServiceCall from "../_Utils/AppDocuServiceCall";

export default class AddGenDocumentDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: AddGenDocumentDialog.getInitialItemData(),
    };
    this.fileInputRef = React.createRef();
  }

  static getInitialItemData() {
    return {
      file: null,
      name: '',
      folder: '',
      description: '',
      language: '',
      original_filename: '',
      com_brand: '',
    };
  }

  addService = async (formData) => {
    try {
      const res = await AppDocuServiceCall.createGenDocument(formData);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error adding gen document', 'error');
        return;
      }
      await this.props.onItemsChange();
      this.props.onClose();
    } catch (error) {
      console.error('Error adding gen document:', error);
      notifySomething('Error adding gen document', 'error');
    }
  };

  handleAdd = async () => {
    const m = this.state.itemData || {};
    const formData = new FormData();
    if (m.file) formData.append('file', m.file);
    formData.append('name', m.name || '');
    formData.append('folder', m.folder || '');
    formData.append('description', m.description || '');
    formData.append('language', m.language || '');
    formData.append('com_brand', m.com_brand || '');
    await this.addService(formData);
  };

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ itemData: AddGenDocumentDialog.getInitialItemData() });
    }
  }

  render() {
    const handleFileChange = (e) => {
      const file = e.target.files && e.target.files[0];
      if (file) {
        const nameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
        this.setState({ itemData: { ...this.state.itemData, file, name: nameWithoutExt } });
      }
    };
    const handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const file = e.dataTransfer.files && e.dataTransfer.files[0];
      if (file) {
        const nameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
        this.setState({ itemData: { ...this.state.itemData, file, name: nameWithoutExt } });
      }
    };
    const handleDragOver = (e) => { e.preventDefault(); e.stopPropagation(); };
    const handleClickDropArea = () => { if (this.fileInputRef.current) this.fileInputRef.current.click(); };

    return (
      <Dialog open={!!this.props.isOpen} onClose={this.props.onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Add New Gen Document</DialogTitle>
        <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
          <Stack spacing={2}>
            <div
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              onClick={handleClickDropArea}
              style={{
                border: '2px dashed #1976d2',
                borderRadius: 8,
                padding: 20,
                textAlign: 'center',
                color: '#1976d2',
                background: '#f5faff',
                cursor: 'pointer',
                marginBottom: 8
              }}
            >
              Trascina qui il file da caricare oppure clicca per selezionarlo
              <input
                type="file"
                ref={this.fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
              {this.state.itemData.file && (
                <div style={{ marginTop: 8, color: '#333' }}>
                  File selezionato: {this.state.itemData.file.name}
                </div>
              )}
            </div>
            <GenDocumentDialogForm
              itemData={this.state.itemData}
              onChange={newData => this.setState({ itemData: newData })}
              hideOriginalFilename={true}
              disabled={false}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <Button onClick={this.handleAdd} color="primary">Add</Button>
        </DialogActions>
      </Dialog>
    );
  }
}
